export const usersCountryList = ["--Select--", "Germany", "Canada", "Usa", "Aus"];

export const addProjectsUploadHead = [
    { name: 'Project Name' },
    { name: 'Date' },
    { name: 'Status' },
    { name: 'Price' },
    { name: '' },
]

export const addProjectTable = [
    {
        id: 1,
        projectName: "Aeroquest",
        date: "28 May 2024",
        status: "Completed",
        price: "$56,908",
        color: 'success'
    },
    {
        id: 2,
        projectName: "Aquasynth",
        date: "12 June 2024",
        status: "On going",
        price: "$45,087",
        color: 'danger'
    },
    {
        id: 3,
        projectName: "Robogenix",
        date: "12 June 2024",
        status: "Pending",
        price: "$60,123",
        color: 'warning'
    },
    {
        id: 4,
        projectName: "Energyharbor",
        date: "14 June 2024",
        status: "Pending",
        price: "$70,435",
        color: 'warning'
    },
    {
        id: 5,
        projectName: "Nanosphere",
        date: "25 June 2024",
        status: "Completed",
        price: "$15,987",
        color: 'success'
    }
]

//user-cards
export const socialCardLinkList = [
    {
        id: 1,
        link: "https://www.facebook.com/",
        icon: 'facebook'
    },
    {
        id: 2,
        link: "https://accounts.google.com/",
        icon: 'google-plus'
    },
    {
        id: 3,
        link: "https://twitter.com/",
        icon: 'twitter'
    },
    {
        id: 4,
        link: "https://www.instagram.com/",
        icon: 'instagram'
    },
    {
        id: 5,
        link: "https://rss.app/",
        icon: 'rss'
    },
]